export default "__VITE_ASSET__D3ZG9zcp__"